import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from './api.service';

export interface ImageUploadResponse {
  id: number;
  name: string;
  image_file: string;
  created_at: string;
  updated_at: string;
}

@Injectable({
  providedIn: 'root',
})
export class ImageUploadService {
  constructor(private apiService: ApiService) {}

  uploadImage(file: File, name?: string): Observable<ImageUploadResponse> {
    const formData = new FormData();
    formData.append('image_file', file);
    formData.append('name', name || file.name);

    return this.apiService.buildAPIPost<any>('/miscelania/images/', formData);
  }
}